import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconScanFile",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, v, u, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--scan-file"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Scan File",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1A1.5 1.5 0 0 1 2.5 1h1a.5.5 0 0 1 0 1h-1ZM8 1.5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 11 2.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5ZM3.57 3.067a1.06 1.06 0 0 1 .734-.317h2.388a.5.5 0 0 1 .353.145l1.557 1.547a.5.5 0 0 1 .148.355V8.2c0 .301-.147.56-.32.733a1.056 1.056 0 0 1-.734.317H4.304c-.3 0-.559-.144-.733-.317A1.049 1.049 0 0 1 3.25 8.2V3.8c0-.301.147-.56.32-.733ZM7.21 4.47l-.19-.19v.19h.19Zm-1.19-.72v1.219a.5.5 0 0 0 .5.5h1.23v2.72a.13.13 0 0 1-.025.034.132.132 0 0 1-.038.027H4.311a.132.132 0 0 1-.036-.027.128.128 0 0 1-.025-.034V3.811a.13.13 0 0 1 .025-.034.132.132 0 0 1 .038-.027h1.706ZM1.5 8a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 9.5v-1a.5.5 0 0 1 .5-.5Zm9 0a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 9.5 11h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, h);
}
const S = /* @__PURE__ */ s(c, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=scan-file.js.map
